module.exports = __webpack_public_path__ + "img/1498149955.691743a8.jpg";